import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DOWNLOAD_CONSULTATION_HISTORY = 'DOWNLOAD_CONSULTATION_HISTORY';
export const DOWNLOAD_CONSULTATION_HISTORY_SUCCESS =
  'DOWNLOAD_CONSULTATION_HISTORY_SUCCESS';
export const DOWNLOAD_CONSULTATION_HISTORY_FAILURE =
  'DOWNLOAD_CONSULTATION_HISTORY_FAILURE';

// Action Creators
export const downloadConsultationHistory = () => ({
  type: DOWNLOAD_CONSULTATION_HISTORY,
});

export const downloadConsultationHistorySuccess = (users) => ({
  type: DOWNLOAD_CONSULTATION_HISTORY_SUCCESS,
  payload: users,
});

export const downloadConsultationHistoryFailure = (error) => ({
  type: DOWNLOAD_CONSULTATION_HISTORY_FAILURE,
  payload: error,
});

// Thunk Function
export const downloadConsultationHistoryCallAPI = (external, data) => {
  return async (dispatch) => {
    dispatch(downloadConsultationHistory());
    try {
      const response = await getMethodWithToken(
        url.consultationHistory + data,
        external.isDownload ? true : false
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(downloadConsultationHistorySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(downloadConsultationHistoryFailure(error?.message));
    }
  };
};
